<template>
    <div>
        <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item md-size-33">
                <md-card>
                    <md-card-header>
                        <div class="md-title">唤醒设置</div>
                    </md-card-header>

                    <md-card-content>
                        <div class="md-layout md-alignment-center-center">
                            <div class="md-layout-item md-size-66">
                                <md-field>
                                    <label for="wakeupStyle">唤醒方式</label>
                                    <md-select v-model="wakeupStyle" name="wakeupStyle" id="wakeupStyle"
                                               @md-selected="setVoiceWakeup">
                                        <md-option value="0">语音唤醒，手机拾音</md-option>
                                        <md-option value="1" disabled>语音唤醒，设备拾音</md-option>
                                        <md-option value="2">事件唤醒，手机拾音</md-option>
                                        <md-option value="3">事件唤醒，设备拾音</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout md-alignment-center-center" v-if="voiceWakeup">
                            <div class="md-layout-item md-size-66">
                                <md-field>
                                    <label>唤醒词</label>
                                    <md-input v-model="wakeupWord" placeholder="设置唤醒词"></md-input>
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout md-alignment-center-center" id="wakeup_threshold" v-if="voiceWakeup">
                            <div class="md-layout-item">
                                <input type="range" v-model.number="wakeupWordThreshold" step="0.01" min="0.01"
                                       max="0.99">
                                Android唤醒阈值：{{ wakeupWordThreshold.toFixed(2) }}
                            </div>
                        </div>
                        <div class="md-layout md-alignment-center-center" id="wakeup_threshold_ios" v-if="voiceWakeup">
                            <div class="md-layout-item">
                                <input type="range" v-model.number="wakeupWordThresholdIos" step="0.01" min="0.01"
                                       max="0.99">
                                Ios唤醒阈值：{{ wakeupWordThresholdIos.toFixed(2) }}
                            </div>
                        </div>
                        <div class="md-layout md-alignment-center-center" v-if="voiceWakeup">
                            <div class="md-layout-item md-size-66">
                                <md-field>
                                    <label>唤醒词提示</label>
                                    <md-input v-model="wakeupWordTips" placeholder="显示在APP上提示用户用语"></md-input>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions>
                        <md-button class="md-raised md-primary" @click="saveSettings">保存</md-button>
                    </md-card-actions>
                </md-card>
            </div>
        </div>

        <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>
    </div>
</template>

<script>
    export default {
        name: "CompanySettings",
        data: () => ({
            companyId: 0,
            companySettings: null,
            wakeupWord: '',
            wakeupWordTips: '',
            wakeupWordThreshold: 0.5,
            wakeupWordThresholdIos: 0.5,
            wakeupStyle: 0,
            voiceWakeup: true,
            toast: false,
            toastMsg: "",
        }),
        mounted() {
            this.companyId = this.$route.params.company_id
            this.obtainSettings();
        },
        methods: {
            obtainSettings: function () {
                this.$http.get('/api/company/settings/' + this.companyId + '/').then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.companySettings = data.data;
                                if (!this.companySettings) return;
                                if (this.companySettings.wakeup_style) {
                                    this.wakeupStyle = this.companySettings.wakeup_style;
                                } else {
                                    this.wakeupStyle = 0;
                                }
                                this.voiceWakeup = parseInt(this.wakeupStyle) === 0 || parseInt(this.wakeupStyle) === 1;
                                if (this.voiceWakeup) {
                                    let wakeupSettings = this.companySettings.wakeup_settings;
                                    if (wakeupSettings.length > 0) {
                                        this.wakeupWord = wakeupSettings[0].wakeup_word;
                                        this.wakeupWordThreshold = wakeupSettings[0].threshold;
                                        this.wakeupWordThresholdIos = wakeupSettings[0].threshold_ios;
                                        this.wakeupWordTips = wakeupSettings[0].wakeup_word_tips;
                                    } else {
                                        this.wakeupWord = '';
                                        this.wakeupWordThreshold = null;
                                        this.wakeupWordThresholdIos = null;
                                    }
                                }
                            } else {
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    default:
                                        this.showErrorTips('请求失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            saveSettings: function () {
                this.$http.post('/api/company/settings/' + this.companyId + '/', {
                    wakeup_style: parseInt(this.wakeupStyle),
                    wakeup_settings: [
                        {
                            wakeup_word: this.wakeupWord,
                            threshold: this.wakeupWordThreshold,
                            threshold_ios: this.wakeupWordThresholdIos,
                            wakeup_word_tips: this.wakeupWordTips
                        }
                    ]
                }).then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.showTips('保存成功');
                            } else {
                                switch (data.code) {
                                    case 3000:
                                        this.showErrorTips('当前账号没有权限（3000）');
                                        break;
                                    default:
                                        this.showErrorTips('请求失败，服务器返回错误码' + data.code);
                                        break
                                }
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            setVoiceWakeup: function () {
                this.voiceWakeup = parseInt(this.wakeupStyle) === 0 || parseInt(this.wakeupStyle) === 1
            },
            showTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
            showErrorTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
        }
    }
</script>

<style scoped>
    #wakeup_threshold {
        margin-top: 10px;
        margin-bottom: 10px;
        margin-left: 35px;
    }
</style>